export const MidRiseApartmentsHero = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c625787274b5709063a42ef7a4e2ba23.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-24 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          We Buy Mid-Rise Apartment Buildings
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/95 max-w-3xl mx-auto leading-relaxed">
          Specializing in 4-8 story apartment buildings. Fast closings, competitive offers, and hassle-free transactions for mid-rise properties.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#get-offer" 
            className="whitespace-nowrap bg-teal-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Get Your Cash Offer
          </a>
          <a 
            href="#our-process" 
            className="whitespace-nowrap bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer"
          >
            See How It Works
          </a>
        </div>
      </div>
    </section>
  );
};